module.exports = __webpack_public_path__ + "assets/img/a0b9a56edf7788a78e64cf539f167e52.png";